import React from 'react';
//import mz styles all
// import '../../templates/vtex-apps/mz-styles-all.scss'
import { useSelector } from 'react-redux';
import { footerPageObject, headerPageObject, selectedPageObject } from '../../redux/pagesSlice';
import IconPackImport from './IconPackImport';
import CanvasCSSVariablesImport from './CanvasCSSVariablesImport';
import { IntlProvider } from 'react-intl';
import { Box } from '@chakra-ui/react';
import VtexVisualizationComponent from './VtexVisualizationComponent';
import VtexFixedComponent from './VtexFixedComponent';
import { selectedToggleValue } from '../../redux/canvasResolutionSlice';

const VisualizationIframeContent = ({ viewId }) => {
	const headerLayout = useSelector(headerPageObject).pageData;
	const footerLayout = useSelector(footerPageObject).pageData;
	const toggleValue = useSelector(selectedToggleValue);
	const selectedPage = useSelector(selectedPageObject);

	return (
		<>
			<IconPackImport />
			<CanvasCSSVariablesImport {...{ viewId }} />
			<IntlProvider locale="br" defaultLocale="br">
				<Box className="canvas-iframe canvas">
					<RenderHeader headerLayout={headerLayout} selectedCanvasResolution={toggleValue} />
					{selectedPage.pageData.map((component, index, arr) => {
						return (
							<VtexVisualizationComponent
								{...{
									componentId: component.componentId,
									comp: component,
									componentGroup: component.componentGroup,
								}}
							/>
						);
					})}
					<RenderFooter footerLayout={footerLayout} selectedCanvasResolution={toggleValue} />
				</Box>
			</IntlProvider>
		</>
	);
};

const RenderHeader = ({ headerLayout, selectedCanvasResolution }) => {
	if (headerLayout.length) {
		const headerComp = headerLayout.filter(
			(el) => el.componentGroup === (selectedCanvasResolution > 1024 ? 'HeaderDesktop' : 'HeaderMobile'),
		)[0];
		return (
			<VtexFixedComponent
				className="VtexComponent"
				{...{
					index: 0,
					comp: headerComp,
					componentChildren: headerComp.componentChildren,
				}}
			/>
		);
	} else {
		return null;
	}
};

const RenderFooter = ({ footerLayout, selectedCanvasResolution }) => {
	if (footerLayout.length) {
		const footerComp = footerLayout.filter(
			(el) => el.componentGroup === (selectedCanvasResolution > 1024 ? 'FooterDesktop' : 'FooterMobile'),
		)[0];
		return (
			<VtexFixedComponent
				className="VtexComponent"
				{...{
					index: 99,
					componentId: footerComp.componentId,
					key: footerComp.componentId,
					comp: footerComp,
					componentChildren: footerComp.componentChildren,
					zIndex: 999,
					name: footerComp.componentName,
				}}
			/>
		);
	} else {
		return null;
	}
};

export default VisualizationIframeContent;
